import "./style.css";
import Modal from "react-bootstrap/Modal";
import { useContext, useEffect, useState } from "react";
import Tippy from "@tippyjs/react";
import invoiceIcon from "../../../images/icons/info 1.png";
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";
import { ConfigContext } from "../../../App";

function UserEditView(props) {
  const { brList, godowList, companyListMap } = props;
  const [user, setUser] = useState({});
  const accessCode = useContext(ConfigContext)?.accessCode;

  useEffect(function () {
    if (localStorage.getItem("inventory")) {
      setUser(JSON.parse(localStorage.getItem("inventory")).userData);
    }
  }, []);

  const roleListIng = [
    { id: 1, title: "Super Admin" },
    { id: 2, title: "Admin" },
    { id: 3, title: "Branch Owner" },
    { id: 4, title: "Cashier" },
    { id: 5, title: "Godown Manager" },
    { id: 6, title: "Customer" },
    { id: 7, title: "Associate Cashier" },
    { id: 8, title: "No Cash Cashier" },
    { id: 9, title: "Cash Expense Cashier" },
    { id: 10, title: "Connector" },
  ];

  const selectedCompany = companyListMap?.find(
    (company) => company.value == props.id?.comp_id,
  );
  console.log("selectedCompanyselectedCompany", selectedCompany);
  const isAccessCodeRequired =
    (user.role_id == 2 && accessCode == 1 && props?.id?.role_id == 3) ||
    (user.role_id == 1 && selectedCompany?.access == 1);
  return (
    <>
      <Modal.Header closeButton>
        <h4 style={{ marginLeft: "12rem", height: "4px" }} id="modalhead">
          View User
        </h4>
      </Modal.Header>
      <div className="container-fluid p-4" id="userAdd">
        <form className="row gx-5 gy-2">
          <div className="col-md-6">
            <label htmlFor="user_name">User Name</label>
            <input
              disabled
              type="text"
              className="form-control"
              id="user_name"
              value={props.id?.user_name}
            />
          </div>
          <div className="col-md-6">
            <label htmlFor="mobile">Mobile No</label>
            <input
              disabled
              type="text"
              className="form-control"
              id="mobile"
              value={props.id?.user_mob}
            />
          </div>
          <div className="col-md-6">
            <label htmlFor="pin">PIN</label>
            <input
              disabled
              type="text"
              className="form-control"
              id="pin"
              value={props.id?.pin}
            />
          </div>
          <div className="col-md-6">
            <label htmlFor="role_id">User Role</label>
            <input
              disabled
              type="text"
              className="form-control"
              id="mobile"
              value={
                roleListIng.find((el) => el.id === props.id?.role_id).title
              }
            />
          </div>
          {user.role_id === 1 ? (
            <div className="col-md-6">
              <label htmlFor="role_id">Company Name</label>
              <input
                disabled
                type="text"
                className="form-control"
                id="mobile"
                value={
                  companyListMap?.find((el) => el?.value == props.id?.comp_id)
                    ?.label
                }
              />
            </div>
          ) : (
            ""
          )}
          {isAccessCodeRequired && (
            <div className="col-md-6">
              <label htmlFor="access_code">Access Code</label>
              <input
                maxLength={4}
                type="text"
                className="form-control"
                id="access_code"
                value={props.id?.access_code}
                disabled
              />
            </div>
          )}
          {user.role_id === 2 &&
          (props.id.role_id == 3 ||
            props.id.role_id == 4 ||
            props.id.role_id == 8 ||
            props.id.role_id == 9 ||
            props.id.role_id == 7 ||
            props.id.role_id == 5) ? (
            <div className="col-md-6">
              <label htmlFor="role_id">Branch Name</label>
              <input
                disabled
                type="text"
                className="form-control"
                id="mobile"
                value={
                  brList.find(
                    (el) => el?.value == props.id?.user_branch?.branch_id,
                  )?.label
                }
              />
            </div>
          ) : (
            ""
          )}
          {user.role_id === 2 && props.id.role_id == 5 ? (
            <div className="col-md-6">
              <label htmlFor="role_id">Godown Name</label>
              <input
                disabled
                type="text"
                className="form-control"
                id="mobile"
                value={
                  godowList.find(
                    (el) => el?.value == props.id?.user_godown?.godown_id,
                  )?.label
                }
              />
            </div>
          ) : (
            ""
          )}
          {user.role_id != 1 && props.id.role_id === 2 && (
            <div className="col-md-6">
              <label htmlFor="cut_off_days">
                Cut off days{" "}
                <Tippy
                  placement="top"
                  content={`Cut Off: Set data visibility up to 90 days. '0' means all data visible. User can see latest ${props?.id?.company?.cut_off_days} days data.`}
                >
                  <img
                    src={invoiceIcon}
                    className="img-fluid me-3"
                    alt=""
                    role="button"
                    style={{
                      width: "16px",
                      height: "16px",
                      alignItems: "center",
                      marginLeft: "10px",
                      marginBottom: "6px",
                    }}
                  />
                </Tippy>
              </label>
              <input
                type="text"
                // onKeyDown={}
                className="form-control"
                id="cut_off_days"
                value={props.id.company?.cut_off_days}
                disabled
              />
            </div>
          )}
          {user.role_id != 1 && props.id.role_id == 2 && (
            <div className="col-md-6">
              <label htmlFor="comp_id">Item Narration</label>
              <select
                className="form-select"
                id="item_level_narration"
                value={props.id.company?.item_level_narration}
                disabled
              >
                <option value="" hidden>
                  Select...
                </option>
                <option value="0">No</option>
                <option value="1">Yes</option>
              </select>
            </div>
          )}

          <div className="col-md-6">
            <label htmlFor="back_date">Back Days</label>
            <InputGroup className="">
              <Form.Control
                icon={"Days"}
                maxLength={3}
                disabled
                type="text"
                inputStyle={{ height: "34px" }}
                className="form-control"
                style={{
                  borderTopRightRadius: "0",
                  borderBottomRightRadius: "0",
                }}
                id="back_date"
                value={props.id?.back_date}
              />
              <InputGroup.Text id="basic-addon2">Days</InputGroup.Text>
            </InputGroup>
          </div>
          <div className="col-12 mt-4">
            <button
              onClick={props.hide}
              type="button"
              className="branchModalCancel"
              style={{
                height: "33px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                float: "right",
              }}
            >
              Cancel
            </button>
          </div>
        </form>
      </div>
    </>
  );
}

export default UserEditView;
